import amparo from "./amparo.json";
import anticorrupcion from "./anticorrupcion.json";
import comerciointernacional from "./comerciointernacional.json";
import compliance from "./compliance.json";
import corredorespublicos from "./corredorespublicos.json";
import defensadelconsumidor from "./defensadelconsumidor.json";
import derechoaduanero from "./derechoaduanero.json";
import derechoagrario from "./derechoagrario.json";
import derechoambiental from "./derechoambiental.json";
import derechobancario from "./derechobancario.json";
import derechocanonico from "./derechocanonico.json";
import derechocivil from "./derechocivil.json";
import derechoconstitucional from "./derechoconstitucional.json";
import derechocorporativo from "./derechocorporativo.json";
import derechodelapropiedadintelectual from "./derechodelapropiedadintelectual.json";
import derechodeportivo from "./derechodeportivo.json";
import derechodeseguridadsocial from "./derechodeseguridadsocial.json";
import derechoeducativo from "./derechoeducativo.json";
import derechoelectoral from "./derechoelectoral.json";
import derechoenergetico from "./derechoenergetico.json";
import derechoentelecomunicaciones from "./derechoentelecomunicaciones.json";
import derechofamiliar from "./derechofamiliar.json";
import derechofiscal from "./derechofiscal.json";
import derechoinformatico from "./derechoinformatico.json";
import derechoinmobiliario from "./derechoinmobiliario.json";
import derecholaboral from "./derecholaboral.json";
import derechomaritimoaeronautico from "./derechomaritimoaeronautico.json";
import derechomercantil from "./derechomercantil.json";
import derechomigratorio from "./derechomigratorio.json";
import derechomilitar from "./derechomilitar.json";
import derechomineroypetrolero from "./derechomineroypetrolero.json";
import derechomunicipal from "./derechomunicipal.json";
import derechopenal from "./derechopenal.json";
import derechoshumanos from "./derechoshumanos.json";
import derechotributario from "./derechotributario.json";
import derechourbanistico from "./derechourbanistico.json";
import fusionesadquisiciones from "./fusionesadquisiciones.json";
import legislacionmedica from "./legislacionmedica.json";
import mediacionarbitraje from "./mediacionarbitraje.json";
import mercadodecapitales from "./mercadodecapitales.json";
import negligenciamedica from "./negligenciamedica.json";
import negligenciaslegales from "./negligenciaslegales.json";
import norma035 from "./norma035.json";
import peritoscontables from "./peritoscontables.json";
import peritostraductores from "./peritostraductores.json";
import peritosvaluadores from "./peritosvaluadores.json";
import prevenciondelavado from "./prevenciondelavado.json";
import propiedadindustrial from "./propiedadindustrial.json";
import propiedadintelectual from "./propiedadintelectual.json";
import protecciondedatospersonales from "./protecciondedatospersonales.json";
import segurosfianzas from "./segurosfianzas.json";

export const filterSubSpecialties = specialty => {
    let filteredSubSpecialties
    switch (specialty) {
        case 'Anti corrupción':
            filteredSubSpecialties = anticorrupcion
            break;
        case 'Amparo':
            filteredSubSpecialties = amparo
            break;
        case 'Comercio internacional':
            filteredSubSpecialties = comerciointernacional
            break;
        case 'Compliance':
            filteredSubSpecialties = compliance
            break;
        case 'Derecho civil':
            filteredSubSpecialties = derechocivil
            break;
        case 'Derecho penal':
            filteredSubSpecialties = derechopenal
            break;
        case 'Derecho mercantil':
            filteredSubSpecialties = derechomercantil
            break;
        case 'Derecho familiar':
            filteredSubSpecialties = derechofamiliar
            break;
        case 'Derecho laboral':
            filteredSubSpecialties = derecholaboral
            break;
        case 'Derecho de seguridad social':
            filteredSubSpecialties = derechodeseguridadsocial
            break;
        case 'Derecho constitucional':
            filteredSubSpecialties = derechoconstitucional
            break;
        case 'Derechos humanos':
            filteredSubSpecialties = derechoshumanos
            break;
        case 'Derecho fiscal':
            filteredSubSpecialties = derechofiscal
            break;
        case 'Derecho administrativo':
            filteredSubSpecialties = []
            break;
        case 'Derecho corporativo':
            filteredSubSpecialties = derechocorporativo
            break;
        case 'Derecho de la propiedad intelectual':
            filteredSubSpecialties = derechodelapropiedadintelectual
            break;
        case 'Derecho energético':
            filteredSubSpecialties = derechoenergetico
            break;
        case 'Derecho en telecomunicaciones':
            filteredSubSpecialties = derechoentelecomunicaciones
            break;
        case 'Defensa del consumidor':
            filteredSubSpecialties = defensadelconsumidor
            break;
        case 'Derecho aduanero':
            filteredSubSpecialties = derechoaduanero
            break;
        case 'Derecho agrario':
            filteredSubSpecialties = derechoagrario
            break;
        case 'Derecho ambiental':
            filteredSubSpecialties = derechoambiental
            break;
        case 'Derecho migratorio':
            filteredSubSpecialties = derechomigratorio
            break;
        case 'Derecho bancario':
            filteredSubSpecialties = derechobancario
            break;
        case 'Derecho canónico':
            filteredSubSpecialties = derechocanonico
            break;
        case 'Derecho deportivo':
            filteredSubSpecialties = derechodeportivo
            break;
        case 'Derecho educativo':
            filteredSubSpecialties = derechoeducativo
            break;
        case 'Derecho electoral':
            filteredSubSpecialties = derechoelectoral
            break;
        case 'Derecho informático':
            filteredSubSpecialties = derechoinformatico
            break;
        case 'Derecho inmobiliario':
            filteredSubSpecialties = derechoinmobiliario
            break;
        case 'Derecho marítimo y aeronáutico':
            filteredSubSpecialties = derechomaritimoaeronautico
            break;
        case 'Legislación médica':
            filteredSubSpecialties = legislacionmedica
            break;
        case 'Derecho militar':
            filteredSubSpecialties = derechomilitar
            break;
        case 'Derecho minero y petrolero':
            filteredSubSpecialties = derechomineroypetrolero
            break;
        case 'Derecho municipal':
            filteredSubSpecialties = derechomunicipal
            break;
        case 'Derecho tributario':
            filteredSubSpecialties = derechotributario
            break;
        case 'Derecho urbanístico':
            filteredSubSpecialties = derechourbanistico
            break;
        case 'Fusiones y adquisiciones':
            filteredSubSpecialties = fusionesadquisiciones
            break;
        case 'Negligencia médica':
            filteredSubSpecialties = negligenciamedica
            break;
        case 'Norma 035':
            filteredSubSpecialties = norma035
            break;
        case 'Mediación y arbitraje':
            filteredSubSpecialties = mediacionarbitraje
            break;
        case 'Mercado de capitales':
            filteredSubSpecialties = mercadodecapitales
            break;
        case 'Negligencias legales':
            filteredSubSpecialties = negligenciaslegales
            break;
        case 'Propiedad industrial':
            filteredSubSpecialties = propiedadindustrial
            break;
        case 'Propiedad intelectual':
            filteredSubSpecialties = propiedadintelectual
            break;
        case 'Corredores públicos':
            filteredSubSpecialties = corredorespublicos
            break;
        case 'Peritos contables':
            filteredSubSpecialties = peritoscontables
            break;
        case 'Peritos traductores':
            filteredSubSpecialties = peritostraductores
            break;
        case 'Peritos valuadores':
            filteredSubSpecialties = peritosvaluadores
            break;
        case 'Prevención de lavado':
            filteredSubSpecialties = prevenciondelavado
            break;
        case 'Protección de datos personales':
            filteredSubSpecialties = protecciondedatospersonales
            break;
        case 'Seguros / Fianzas':
            filteredSubSpecialties = segurosfianzas
            break;
        case 'all of them':
            filteredSubSpecialties = [
                ...amparo,
                ...anticorrupcion,
                ...comerciointernacional,
                ...compliance,
                ...corredorespublicos,
                ...defensadelconsumidor,
                ...derechoaduanero,
                ...derechoagrario,
                ...derechoambiental,
                ...derechobancario,
                ...derechocanonico,
                ...derechocivil,
                ...derechoconstitucional,
                ...derechocorporativo,
                ...derechodelapropiedadintelectual,
                ...derechodeportivo,
                ...derechodeseguridadsocial,
                ...derechoeducativo,
                ...derechoelectoral,
                ...derechoenergetico,
                ...derechoentelecomunicaciones,
                ...derechofamiliar,
                ...derechofiscal,
                ...derechoinformatico,
                ...derechoinmobiliario,
                ...derecholaboral,
                ...derechomaritimoaeronautico,
                ...derechomercantil,
                ...derechomigratorio,
                ...derechomilitar,
                ...derechomineroypetrolero,
                ...derechomunicipal,
                ...derechopenal,
                ...derechoshumanos,
                ...derechotributario,
                ...derechourbanistico,
                ...fusionesadquisiciones,
                ...legislacionmedica,
                ...mediacionarbitraje,
                ...mercadodecapitales,
                ...negligenciamedica,
                ...negligenciaslegales,
                ...norma035,
                ...peritoscontables,
                ...peritostraductores,
                ...peritosvaluadores,
                ...prevenciondelavado,
                ...propiedadindustrial,
                ...propiedadintelectual,
                ...protecciondedatospersonales,
                ...segurosfianzas,
            ]
            break;
        default:
            filteredSubSpecialties = []
            break;
    }
    return filteredSubSpecialties
}

export const filteredSubSpecialities = (specialty, subSpecialities) => {
    let result = []
    if (subSpecialities && subSpecialities.length) {
        const matchedSubspecialities = filterSubSpecialties(specialty)
        const intersection = matchedSubspecialities.filter(element => subSpecialities.includes(element));
        result = intersection
    }
    return result
}

export const filterExtraSubs = (specialty, extrasSubsArray) => {
    let extraSubs = []
    if (extrasSubsArray && extrasSubsArray.length && extrasSubsArray.length !== 0) {
        const extras = extrasSubsArray.filter((elem) => {
            const objKeys = Object.keys(elem)
            return objKeys[0] === specialty
        })
        if (extras && extras.length && extras.length !== 0) {
            extraSubs = extras[0][`${specialty}`]
        }
    }
    return extraSubs
}

export const getSpecialityWithSub = (subSpeciality) => {
    let index = ''
    let values = Object.values(SPEANDSUB)
    let keys = Object.keys(SPEANDSUB)
    let sub = ''
    index = values.findIndex(elem => {
        return elem.includes(subSpeciality)
    })
    if (index >= 0) {
        sub = keys[index]
    }
    return sub
}

export const SPEANDSUB = {
    'Anti corrupción': anticorrupcion,
    'Amparo': amparo,
    'Comercio internacional': comerciointernacional,
    'Compliance': compliance,
    'Derecho civil': derechocivil,
    'Derecho penal': derechopenal,
    'Derecho mercantil': derechomercantil,
    'Derecho familiar': derechofamiliar,
    'Derecho laboral': derecholaboral,
    'Derecho de seguridad social': derechodeseguridadsocial,
    'Derecho constitucional': derechoconstitucional,
    'Derechos humanos': derechoshumanos,
    'Derecho fiscal': derechofiscal,
    'Derecho administrativo': [],
    'Derecho corporativo': derechocorporativo,
    'Derecho de la propiedad intelectual': derechodelapropiedadintelectual,
    'Derecho energético': derechoenergetico,
    'Derecho en telecomunicaciones': derechoentelecomunicaciones,
    'Defensa del consumidor': defensadelconsumidor,
    'Derecho aduanero': derechoaduanero,
    'Derecho agrario': derechoagrario,
    'Derecho ambiental': derechoambiental,
    'Derecho migratorio': derechomigratorio,
    'Derecho bancario': derechobancario,
    'Derecho canónico': derechocanonico,
    'Derecho deportivo': derechodeportivo,
    'Derecho educativo': derechoeducativo,
    'Derecho electoral': derechoelectoral,
    'Derecho informático': derechoinformatico,
    'Derecho inmobiliario': derechoinmobiliario,
    'Derecho marítimo y aeronáutico': derechomaritimoaeronautico,
    'Legislación médica': legislacionmedica,
    'Derecho militar': derechomilitar,
    'Derecho minero y petrolero': derechomineroypetrolero,
    'Derecho municipal': derechomunicipal,
    'Derecho tributario': derechotributario,
    'Derecho urbanístico': derechourbanistico,
    'Fusiones y adquisiciones': fusionesadquisiciones,
    'Negligencia médica': negligenciamedica,
    'Norma 035': norma035,
    'Mediación y arbitraje': mediacionarbitraje,
    'Mercado de capitales': mercadodecapitales,
    'Negligencias legales': negligenciaslegales,
    'Propiedad industrial': propiedadindustrial,
    'Propiedad intelectual': propiedadintelectual,
    'Corredores públicos': corredorespublicos,
    'Peritos contables': peritoscontables,
    'Peritos traductores': peritostraductores,
    'Peritos valuadores': peritosvaluadores,
    'Prevención de lavado': prevenciondelavado,
    'Protección de datos personales': protecciondedatospersonales,
    'Seguros / Fianzas': segurosfianzas,
}
